import createConfigurableObject from '../../../utils/configurationObject';

export default (app) => {
    app.vendorRoutes = app.vendorRoutes || createConfigurableObject();
};
